import type { NetworkAdapter } from '../../core';

/**
 * 浏览器端 HTTP 网络适配器
 * 支持标准 fetch、keepalive 连接保持及 sendBeacon 离网兜底
 */
export class BrowserNetwork implements NetworkAdapter {
  public async post(
    url: string,
    data: string | Record<string, unknown>,
    headers: Record<string, string> = {}
  ): Promise<{ status: number; data: any }> {
    const isUrlEncoded = typeof data === 'string';
    const postHeaders: Record<string, string> = {
      'Content-Type': isUrlEncoded ? 'application/x-www-form-urlencoded' : 'application/json',
      ...headers,
    };

    const body = isUrlEncoded ? data : JSON.stringify(data);

    if (typeof fetch === 'function') {
      const response = await fetch(url, {
        method: 'POST',
        headers: postHeaders,
        body,
        keepalive: true, // 页面跳转不中断请求
      });

      let responseData: any = null;
      try {
        responseData = await response.json();
      } catch {
        responseData = null;
      }

      return {
        status: response.status,
        data: responseData,
      };
    }

    // 环境降级：不支持 fetch
    return {
      status: 0,
      data: { code: '0', message: 'No fetch available in this environment' },
    };
  }

  /**
   * 使用 navigator.sendBeacon 发送关键退出埋点
   */
  public sendBeacon(url: string, data: string | Blob): boolean {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      return navigator.sendBeacon(url, data);
    }
    return false;
  }
}
